import Benefits from "../components/ContactUs/Benefits"
import ContactUsSection from "../components/ContactUs/ContactUsSection"
import LetterBox from "../components/ContactUs/LetterBox"

const ContactUs = () => {
  return (
    <>
    <ContactUsSection/>
    <Benefits/>
    <LetterBox/>
    </>
  )
}

export default ContactUs